import { jsx as _jsx } from "react/jsx-runtime";
var DifficultyMedal = function DifficultyMedal(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    className: className,
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.878 3.68c.45-.152.788-.554.788-1.03V1a1 1 0 00-1-1h-2a1 1 0 00-1 1v2.048a1 1 0 00.15.527l.234.377c.324.522 1.035.626 1.563.312a6.61 6.61 0 011.265-.584zM9.334 2.651c0 .476.337.877.787 1.03.445.15.869.346 1.266.583.528.314 1.24.21 1.563-.312l.233-.377a1 1 0 00.15-.527V1a1 1 0 00-1-1h-2a1 1 0 00-1 1v1.651zM8 4.668a5.334 5.334 0 100 10.667A5.334 5.334 0 008 4.668zm2.368 8.621L8 11.57 5.632 13.29l.905-2.784-2.369-1.72h2.928L8 6l.905 2.784h2.927l-2.368 1.721.904 2.783z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default DifficultyMedal;